
import React from 'react';
import { StepBasedStrategyDialog } from './StepBasedStrategyDialog';
import { Strategy } from './types';

interface EnhancedStrategyDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (strategy: Partial<Strategy>) => void;
  initialData?: Partial<Strategy> | null;
  isStewieQuant?: boolean;
}

/**
 * Enhanced strategy dialog that properly handles user-chosen parameters
 * Uses the full StepBasedStrategyDialog for comprehensive parameter configuration
 */
const EnhancedStrategyDialog: React.FC<EnhancedStrategyDialogProps> = ({
  open,
  onOpenChange,
  onSubmit,
  initialData = null,
  isStewieQuant = false
}) => {
  return (
    <StepBasedStrategyDialog 
      open={open} 
      onOpenChange={onOpenChange} 
      onSubmit={onSubmit}
      initialData={initialData}
      isStewieQuant={isStewieQuant}
    />
  );
};

export default EnhancedStrategyDialog;
